import SectionHub from '@/components/docs/SectionHub';

export default function Docs03FundamentalsFinancialsSeriesHub() {
  return <SectionHub sectionPath="03-fundamentals/financials/series" />;
}
